setTimeout(() => {
	const cartBubble = document.getElementById(
		"cart-icon-bubble"
	);

	if (!cartBubble) return;

	// Check if we are on the cart page
	if (window.location.pathname.includes("/cart")) {
		cartBubble.replaceWith(cartBubble.cloneNode(true)); // Remove all event listeners
	}
}, 100); // Delay execution by 1 second

const form = document.getElementById("gift-wrap-form");

// Use event delegation for checkbox change event
document.addEventListener("change", function (event) {
	if (
		event.target &&
		event.target.id == "gift-wrap-checkbox"
	) {
		if (event.target.checked) {
			document
				.getElementById("gift-wrap-form")
				.classList.add("show");
		} else {
			document
				.getElementById("gift-wrap-form")
				.classList.remove("show");
		}
	}
});

document.addEventListener("click", function (event) {
    console.log( 123 )
	if (
		event.target &&
		event.target.id === "add-gift-wrap"
	) {
		const fromField =
			document.getElementById("gift-from");
		const toField = document.getElementById("gift-to");
		const wishesField =
			document.getElementById("gift-wishes");

		const from = fromField.value.trim();
		const to = toField.value.trim();
		const wishes = wishesField.value.trim();

		// Check fields and add 'no_valid' class if empty
		[fromField, toField, wishesField].forEach(
			(field) => {
				if (!field.value.trim()) {
					field.classList.add("no_valid");
				} else {
					field.classList.remove("no_valid");
				}
			}
		);

		if (!from || !to || !wishes) {
			return;
		}

		const giftWrapProductId = event.target.getAttribute(
			"data-product-id"
		); // Liquid variable
		const data = {
			items: [
				{
					id: giftWrapProductId,
					quantity: 1,
					properties: {
						מִן: from,
						אֶל: to,
						משאלות: wishes,
					},
				},
			],
		};

		fetch("/cart/add.js", {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(data),
		})
			.then((response) => response.json())
			.then(() => {
				updateCart(); // Refresh the cart dynamically
				updateCartBubble(); // Refresh the cart bubble dynamically
			})
			.catch((error) =>
				console.error("Error:", error)
			);
	}
});

function updateCart() {
	const cartSection = document.getElementById(
		"main-cart-items"
	);

	if (!cartSection) {
		console.error("Cart section not found.");
		return;
	}

	const sectionId = cartSection.getAttribute("data-id"); // Get section name dynamically

	if (!sectionId) {
		console.error("Cart section ID not found.");
		return;
	}

	const cartUpdateSection = document.getElementById(
		"shopify-section-" + sectionId
	);

	fetch(
		window.location.pathname + `?sections=${sectionId}`
	)
		.then((response) => response.json())
		.then((data) => {
			const updatedCartHTML = data[sectionId]; // Use dynamic section name
			if (updatedCartHTML) {
				cartUpdateSection.outerHTML =
					updatedCartHTML;
			}
		})
		.catch((error) =>
			console.error("Error updating cart:", error)
		);
}

function updateCartBubble() {
	const cartBubbleSection = document.getElementById(
		"cart-icon-bubble"
	);

	fetch(
		window.location.pathname +
			`?sections=cart-icon-bubble`
	)
		.then((response) => response.json())
		.then((data) => {
			const updatedCartHTML =
				data["cart-icon-bubble"]; // Use dynamic section name
			if (updatedCartHTML) {
				cartBubbleSection.innerHTML =
					updatedCartHTML;
			}
		})
		.catch((error) =>
			console.error("Error updating cart:", error)
		);
}
